import React, { useState } from "react";
import { Button, Card, Col, Container, Form, Nav, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import apiClient from "../utils/config/apiClient";
import pageSvg from "../assets/svg/forgot_password.svg";
import { toast } from "sonner";
import logo from "../assets/dedaImg/dedalogo.png"

export default function ForgotPassword() {

  document.body.classList.remove("sidebar-show");

  const [email, setEmail] = useState("")
  const [loading, setLoading]=useState(false)
  const [error, setError] = useState()
  const navigate = useNavigate()
 
  
  const handleSubmit = async (e) => {
    let data = {
      "email":email,
      "reset":true,
    }
    e.preventDefault();
    setLoading(true);
    localStorage.setItem("localEmail", email)
    try {
      const response = await apiClient.post("/public/portal?url=auth/login/patient",
        data
      );

      if (response.data) {
        localStorage.setItem("token", response?.data?.token)
        localStorage.setItem("user", JSON.stringify(response?.data))
        // login(response.data); // Store user data and token in context
        setLoading(false);
        // navigate("/dashboard/finance");
        console.log(response?.data?.message)
        if (response?.data?.otp == true) {
          navigate("/pages/verify")
          toast.success("Email Sent")
          
        } else {
          // navigate("/dashboard/finance")
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
      alert(error);
      setLoading(false);
    }
  };

  return (
    <div className="page-auth">
      <div className="header">
        <Container>
          <Link to="/" className="header-log">
          <img src={logo} alt="Deda Hospital" style={{width:'120px'}}/>
          </Link>
          <Nav className="nav-icon">
            <Nav.Link href=""><i className="ri-twitter-fill"></i></Nav.Link>
            <Nav.Link href=""><i className="ri-github-fill"></i></Nav.Link>
            <Nav.Link href=""><i className="ri-dribbble-line"></i></Nav.Link>
          </Nav>
        </Container>
      </div>

      <div className="content">
        <Container>
          <Card className="card-auth">
            <Card.Body className="text-center">
              <div className="mb-5">
                <object type="image/svg+xml" data={pageSvg} className="w-50" aria-label="svg image"></object>
              </div>
              <Card.Title>Reset your password</Card.Title>
              <Card.Text className="mb-5">Enter your email address and we will send you a link to reset your password.</Card.Text>

              <Row className="g-2">
                <Col sm="8"><Form.Control value={email} onChange={(e)=>setEmail(e.target.value)} type="text" placeholder="Enter email address" /></Col>
                <Col sm="4"><Button variant="primary" onClick={handleSubmit} href="" disabled={loading}>{loading ? "Loading..." : "Reset"}</Button></Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </div>
  );
}